import { GLOBAL_SEARCH_MIN_LENGTH, type GlobalSearchResultDto } from '@osteopro/shared';
import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { api, unwrap } from '../../lib/api.js';
import { runAuthed } from '../../lib/auth-store.js';
import { searchKeys } from '../../lib/query-keys.js';

/**
 * Recherche globale de l'en-tête : dossiers et consultations du cabinet, cinq par groupe.
 *
 * Périmée d'emblée : un dossier créé ou une consultation titrée à l'instant doit se retrouver à la
 * recherche suivante. Les résultats précédents restent affichés pendant la frappe, comme la V1.
 */
export function useGlobalSearch(term: string) {
  const trimmed = term.trim();
  return useQuery({
    queryKey: searchKeys.global(trimmed),
    enabled: trimmed.length >= GLOBAL_SEARCH_MIN_LENGTH,
    staleTime: 0,
    placeholderData: keepPreviousData,
    queryFn: async (): Promise<GlobalSearchResultDto> =>
      runAuthed(async () => unwrap(await api.api.search.$get({ query: { q: trimmed } }))),
  });
}
